import React from "react";

const Privacy_Policy = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-9">
          
          {/* Page Header */}
          <div className="text-center mb-5">
            <h1 className="fw-bold text-dark mb-3">
              Privacy Policy
            </h1>
            <p className="text-muted border-top border-bottom py-3 mx-auto" style={{maxWidth: '400px'}}>
              Last updated: November 13, 2025
            </p>
          </div>

          {/* Introduction */}
          <div className="mb-5 p-4 bg-info bg-opacity-10 border-start border-3 border-info rounded-end">
            <div className="mb-4 text-start">
              <h5 className="text-dark mb-2">MyFoodMyPrice is a product of Biryani Palayam.</h5>
              <p className="fs-6 text-dark mb-0">
                Click here to visit{" "}
                <a href="https://www.biryanipalayam.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-primary fw-semibold border-bottom border-primary">
                  Biryani Palayam
                </a>
              </p>
            </div>
            <p className="fs-5 mb-0 text-dark">
              This Privacy Policy describes how Biryani Palayam, as the owner and operator of MyFoodMyPrice, collects, uses, stores, and discloses Your information when You use the MyFoodMyPrice website, application, and related services. It also explains Your privacy rights and how applicable law protects You.
            </p>
            <p className="fs-5 mb-0 text-dark mt-3">
              We use Your Personal Data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
            </p>
          </div>

          {/* Interpretation and Definitions */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" 
                      style={{width: '36px', height: '36px'}}>
                  1
                </span>
                Interpretation and Definitions
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <h5 className="text-dark mb-3 fw-semibold">Interpretation</h5>
              <div className="d-flex align-items-start mb-4">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">•</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or plural.
                  </p>
                </div>
              </div>
              
              <h5 className="text-dark mb-3 fw-semibold">Definitions</h5>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">Account</p>
                    <p className="small text-dark mb-0">means a unique account created for You to access our Service or parts of our Service.</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">Affiliate</p>
                    <p className="small text-dark mb-0">means an entity that controls, is controlled by, or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest, or other securities entitled to vote for election of directors or other managing authority.</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">Application</p>
                    <p className="small text-dark mb-0">refers to MyFoodMyPrice, the software program provided by the Company. MyFoodMyPrice is a product of Biryani Palayam.</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">Company</p>
                    <p className="small text-dark mb-0">(referred to as either "the Company", "We", "Us", or "Our" in this Privacy Policy) refers to Biryani Palayam, the owner and operator of MyFoodMyPrice, 1, Thayumanasundaram Street, Kollampalayam, Erode – 638002, Tamil Nadu, India.</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">MyFoodMyPrice</p>
                    <p className="small text-dark mb-0">refers to the product, website, application, and online platform owned and operated by Biryani Palayam.</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">Country</p>
                    <p className="small text-dark mb-0">refers to Tamil Nadu, India.</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">Device</p>
                    <p className="small text-dark mb-0">means any device that can access the Service such as a computer, a cellphone, or a digital tablet.</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">Personal Data</p>
                    <p className="small text-dark mb-0">is any information that relates to an identified or identifiable individual.</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">Service</p>
                    <p className="small text-dark mb-0">refers to the Application and website of MyFoodMyPrice, a product owned and operated by Biryani Palayam.</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">Service Provider</p>
                    <p className="small text-dark mb-0">means any natural or legal person who processes the data on behalf of the Company.</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">Usage Data</p>
                    <p className="small text-dark mb-0">refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself.</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="bg-light p-3 rounded-3 h-100">
                    <p className="fw-semibold text-dark mb-1">You</p>
                    <p className="small text-dark mb-0">means the individual accessing or using the Service, or the company or other legal entity on behalf of which such individual is accessing or using the Service.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Collecting and Using Your Personal Data */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3" 
                      style={{width: '36px', height: '36px'}}>
                  2
                </span>
                Collecting and Using Your Personal Data
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <h5 className="text-dark mb-3 fw-semibold">Types of Data Collected</h5>
              
              <div className="mb-4">
                <h6 className="text-dark mb-2 fw-semibold">Personal Data</h6>
                <div className="d-flex align-items-start mb-3">
                  <div className="me-3 mt-1">
                    <div className="bg-success bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center" 
                         style={{width: '24px', height: '24px'}}>
                      <span className="fw-bold">•</span>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0 text-dark">
                      While using Our Service, We may ask You to provide Us with certain personally identifiable information, including but not limited to:
                    </p>
                    <div className="mt-2">
                      <span className="badge bg-success bg-opacity-25 text-dark border border-success border-opacity-25 px-3 py-2 me-2 mb-2">Email address</span>
                      <span className="badge bg-success bg-opacity-25 text-dark border border-success border-opacity-25 px-3 py-2 me-2 mb-2">First name and last name</span>
                      <span className="badge bg-success bg-opacity-25 text-dark border border-success border-opacity-25 px-3 py-2 mb-2">Phone number</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mb-4">
                <h6 className="text-dark mb-2 fw-semibold">Usage Data</h6>
                <div className="d-flex align-items-start mb-3">
                  <div className="me-3 mt-1">
                    <div className="bg-info bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center" 
                         style={{width: '24px', height: '24px'}}>
                      <span className="fw-bold">📊</span>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0 text-dark">
                      Usage Data is collected automatically when using the Service and may include IP address, browser type, pages visited, time and date of visits, time spent on pages, device identifiers, and diagnostic data.
                    </p>
                    <p className="mb-0 text-dark mt-2">
                      When accessing the Service via a mobile device, We may collect mobile-specific information such as device ID, operating system, IP address, and browser type.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="mb-4">
                <h6 className="text-dark mb-2 fw-semibold">Information Collected while Using the Application</h6>
                <div className="d-flex align-items-start">
                  <div className="me-3 mt-1">
                    <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center" 
                         style={{width: '24px', height: '24px'}}>
                      <span className="fw-bold">📍</span>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0 text-dark">
                      With Your prior permission, We may collect:
                    </p>
                    <div className="mt-2">
                      <span className="badge bg-warning bg-opacity-25 text-dark border border-warning border-opacity-25 px-3 py-2 me-2 mb-2">Location information</span>
                      <span className="badge bg-warning bg-opacity-25 text-dark border border-warning border-opacity-25 px-3 py-2 me-2 mb-2">Contacts list</span>
                      <span className="badge bg-warning bg-opacity-25 text-dark border border-warning border-opacity-25 px-3 py-2 mb-2">Camera and photo library access</span>
                    </div>
                    <p className="mb-0 text-dark mt-3">
                      This information is used only to provide and improve Service features. You can enable or disable permissions at any time through Your device settings.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Use of Your Personal Data */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center me-3" 
                      style={{width: '36px', height: '36px'}}>
                  3
                </span>
                Use of Your Personal Data
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">•</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    The Company may use Personal Data to:
                  </p>
                  <ul className="mt-2 mb-0 text-dark">
                    <li>Provide and maintain the Service</li>
                    <li>Manage user accounts</li>
                    <li>Perform contractual obligations</li>
                    <li>Communicate via email, SMS, calls, or push notifications</li>
                    <li>Provide offers, updates, and promotional content (unless opted out)</li>
                    <li>Manage user requests</li>
                    <li>Handle business transfers</li>
                    <li>Analyze usage and improve services</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Sharing Your Personal Data */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" 
                      style={{width: '36px', height: '36px'}}>
                  4
                </span>
                Sharing Your Personal Data
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">•</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    We may share Your information:
                  </p>
                  <ul className="mt-2 mb-0 text-dark">
                    <li>With Service Providers</li>
                    <li>During business transfers</li>
                    <li>With Affiliates and business partners</li>
                    <li>With other users (in public areas)</li>
                    <li>With Your consent</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Other Important Sections */}
          <div className="row mb-5">
            <div className="col-md-6 mb-4">
              <div className="card border-0 shadow-sm rounded-3 h-100">
                <div className="card-header border-0 bg-white py-4">
                  <h5 className="fw-bold mb-0 text-dark">Retention of Your Personal Data</h5>
                </div>
                <div className="card-body">
                  <p className="text-dark small mb-0">
                    We retain Personal Data only as long as necessary to fulfill purposes outlined in this policy or comply with legal obligations.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card border-0 shadow-sm rounded-3 h-100">
                <div className="card-header border-0 bg-white py-4">
                  <h5 className="fw-bold mb-0 text-dark">Transfer of Your Personal Data</h5>
                </div>
                <div className="card-body">
                  <p className="text-dark small mb-0">
                    Your data may be transferred and stored outside Your jurisdiction. By using the Service, You consent to such transfers. We ensure appropriate safeguards are in place.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card border-0 shadow-sm rounded-3 h-100">
                <div className="card-header border-0 bg-white py-4">
                  <h5 className="fw-bold mb-0 text-dark">Delete Your Personal Data</h5>
                </div>
                <div className="card-body">
                  <p className="text-dark small mb-0">
                    You may delete or request deletion of Your Personal Data through account settings or by contacting Us. Certain data may be retained for legal reasons.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card border-0 shadow-sm rounded-3 h-100">
                <div className="card-header border-0 bg-white py-4">
                  <h5 className="fw-bold mb-0 text-dark">Disclosure of Your Personal Data</h5>
                </div>
                <div className="card-body">
                  <p className="text-dark small mb-0">
                    <strong>Business Transactions:</strong> In case of mergers or asset sales, Your data may be transferred with prior notice.<br/><br/>
                    <strong>Law Enforcement & Legal Requirements:</strong> We may disclose Personal Data to comply with legal obligations or protect rights and safety.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card border-0 shadow-sm rounded-3 h-100">
                <div className="card-header border-0 bg-white py-4">
                  <h5 className="fw-bold mb-0 text-dark">Security of Your Personal Data</h5>
                </div>
                <div className="card-body">
                  <p className="text-dark small mb-0">
                    We use commercially acceptable security measures, but no method of transmission or storage is 100% secure.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card border-0 shadow-sm rounded-3 h-100">
                <div className="card-header border-0 bg-white py-4">
                  <h5 className="fw-bold mb-0 text-dark">Children's Privacy</h5>
                </div>
                <div className="card-body">
                  <p className="text-dark small mb-0">
                    Our Service does not target children under 13. We do not knowingly collect data from children without parental consent.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card border-0 shadow-sm rounded-3 h-100">
                <div className="card-header border-0 bg-white py-4">
                  <h5 className="fw-bold mb-0 text-dark">Links to Other Websites</h5>
                </div>
                <div className="card-body">
                  <p className="text-dark small mb-0">
                    We are not responsible for third-party websites or their privacy practices.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card border-0 shadow-sm rounded-3 h-100">
                <div className="card-header border-0 bg-white py-4">
                  <h5 className="fw-bold mb-0 text-dark">Changes to this Privacy Policy</h5>
                </div>
                <div className="card-body">
                  <p className="text-dark small mb-0">
                    We may update this Privacy Policy periodically. Updates will be posted on this page with a revised "Last updated" date.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="card border-0 shadow-sm rounded-3">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center me-3" 
                      style={{width: '36px', height: '36px'}}>
                  5
                </span>
                Contact Us
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start">
                <div className="me-3 mt-1">
                  <div className="bg-dark bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">✉️</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-3 text-dark">
                    If you have any questions about this Privacy Policy, contact us:
                  </p>
                  <div className="text-dark" style={{ lineHeight: '1.8', wordBreak: 'break-word' }}>
                    <div className="mb-2">
                      <strong>By email:</strong>{" "}
                      <a href="mailto:info@myfoodmyprice.com" className="text-decoration-none text-primary fw-semibold border-bottom border-primary">
                        info@myfoodmyprice.com
                      </a>
                    </div>
                    <div className="mb-2">
                      <strong>Biryani Palayam Support:</strong>{" "}
                      <a href="mailto:support@biryanipalayam.com" className="text-decoration-none text-primary fw-semibold border-bottom border-primary">
                        support@biryanipalayam.com
                      </a>
                    </div>
                    <div className="mb-2">
                      <strong>Website:</strong>{" "}
                      <a href="https://www.myfoodmyprice.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-primary fw-semibold border-bottom border-primary">
                        https://www.myfoodmyprice.com
                      </a>
                    </div>
                    <div>
                      <strong>Biryani Palayam Website:</strong>{" "}
                      <a href="https://www.biryanipalayam.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-primary fw-semibold border-bottom border-primary">
                        https://www.biryanipalayam.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Privacy_Policy;